import { DateTimePicker, DateTimePickerProps } from "@mui/x-date-pickers";
import { FieldValidator, useField } from "formik";

interface Props extends DateTimePickerProps<any> {
    name: string;
    label: string;
    helperText?: string;
    onChange?: (value: Date) => void;
    validate?: FieldValidator;
}

const FormDateTimePicker = ({
    name,
    label,
    helperText,
    onChange,
    validate,
    ...rest
}: Props) => {
    const [field, meta, helpers] = useField({ name, validate });
    return (
        <DateTimePicker
            {...rest}
            {...field}
            label={label}
            onChange={(value) => {
                helpers.setValue(value);
                if (onChange) {
                    onChange(value);
                }
            }}
            onError={() => {
                helpers.setError("Please select a future date/time");
            }}
            slotProps={{
                textField: {
                    error: meta.error ? true : false,
                    helperText: meta.error || helperText,
                    variant: "standard",
                },
            }}
        />
    );
};

export default FormDateTimePicker;
